module.exports = __webpack_public_path__ + "static/media/menuHelp.1aa7406d.svg";